module.exports = __webpack_public_path__ + "img/首页2-4.b2e12fba.svg";